import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import { Link } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import { menuColor } from 'helpers/colors';

const styles = (theme) => {
  return {
    button: {
      backgroundColor: 'transparent',
      fontWeight: 'bold',
      borderRadius: 'initial',
      color: menuColor || theme.palette.text.light,
      height: 80,
      padding: '24px 16px 8px',
      [theme.breakpoints.down('sm')]: {
        padding: 8,
        height: 50,
      },
      '&:hover': {
        backgroundColor: 'transparent',
      },
      '&.selected': {
        color: theme.palette.text.primary,
        backgroundColor: 'rgba(255, 255, 255, 0.8)',
      },
      marginLeft: 50,
      [theme.breakpoints.down('md')]: {
        marginLeft: 20,
        fontSize: 12,
      },
      [theme.breakpoints.down('sm')]: {
        marginTop: 10,
        marginRight: 10,
        marginLeft: 10,
        // marginBottom: 20,
      },
      '& .MuiButton-label': {
        padding: 0,
      },
      '&:after': {
        content: '" "',
        position: 'absolute',
        bottom: 0,
        left: 0,
        backgroundColor: theme.palette.primary.main,
        width: 0,
        height: 1,
        transition: theme.transitions.create('width', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
      },
    },
  };
};

class HeaderMenu extends Component {
  contructor(props) {
    this.super(props);
  }

  _onClick(e, href) {
    const id = href.replace('/#', '');
    if (['mission'].indexOf(id) < 0) {
      const top = document.getElementById(id)
        ? document.getElementById(id).offsetTop + 10 - document.getElementById('header').offsetHeight
        : false;
      window.scroll({
        top,
        behavior: 'smooth',
      });
    }
    if (this.props.onClick) this.props.onClick();
  }
  render() {
    const { mode, current, $$menu, classes } = this.props;

    return (
      <React.Fragment>
        {$$menu
          .map((menu, i) => {
            if (menu.get('target') === '_blank')
              return (
                <Button
                  classes={{ root: classes.button }}
                  className={'headerButton' + (current === menu.get('icon') ? ' selected' : '')}
                  key={'lnk_' + i}
                  aria-label={menu.get('title')}
                  onClick={() => {
                    console.log('clicked!');
                    window.open(menu.get('url'));
                  }}
                  disableRipple
                >
                  {menu.get('title')}{' '}
                </Button>
              );
            else
              return (
                <Button
                  classes={{ root: classes.button }}
                  className={current === menu.get('icon') ? ' selected' : ''}
                  key={'lnk_' + i}
                  aria-label={menu.get('title')}
                  component={Link}
                  to={menu.get('url')}
                >
                  {menu.get('title')}{' '}
                </Button>
              );
          })
          .toArray()}
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(HeaderMenu);



// WEBPACK FOOTER //
// ./src/components/Header/HeaderMenu.jsx